/** Mascara (XX) XXXXX-XXXX e conversao de/para o formato salvo (55 + 11 digitos). */
export function mascara(digits) {
  const d = (digits || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : "";
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export function doSalvo(stored) {
  const digits = (stored || "").replace(/\D/g, "");
  return mascara(digits.length === 13 ? digits.slice(2) : digits);
}

export const digitosLocais = (mascarado) => (mascarado || "").replace(/\D/g, "");
export const telefoneValido = (mascarado) => digitosLocais(mascarado).length === 11;
export const paraSalvar = (mascarado) => (telefoneValido(mascarado) ? `55${digitosLocais(mascarado)}` : "");
